/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_Add_Passkey_DescriptionInputs */



/**
* | output |
* | --- |
* | "Create a new passkey to authenticate to your account" |
*
* @param {Profile_Security_Add_Passkey_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_add_passkey_description = /** @type {((inputs?: Profile_Security_Add_Passkey_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_Add_Passkey_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstelle einen neuen Passkey zur Authentifizierung bei deinem Konto")
	return /** @type {LocalizedString} */ ("Create a new passkey to authenticate to your account")
});